import React, { useState } from "react";

import classNames from "classnames";

import style from "./NavGroup.module.css";

export const NavGroupContext = React.createContext({
  setIsActiveMap: (() => {
    // Assigned during context init
  }) as React.Dispatch<React.SetStateAction<object>>,
});

export const NavGroup: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isActiveMap, setIsActiveMap] = useState({});
  const isActive = Object.values(isActiveMap).some(Boolean);

  return (
    <NavGroupContext.Provider value={{ setIsActiveMap }}>
      <span className={classNames(style.container, !isActive && style.hidden)}>{children}</span>
    </NavGroupContext.Provider>
  );
};
